import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    User,
} from 'firebase/auth';
import { doc, setDoc, getDoc, updateDoc, increment } from 'firebase/firestore';
import { auth, db } from '../config/firebase';

export interface UserProfile {
    uid: string;
    email: string;
    displayName?: string;
    credits: number;
    tier: 'micro' | 'small' | 'standard' | 'industrial';
    createdAt: Date;
}

export const signUp = async (
    email: string,
    password: string,
    displayName?: string
  ): Promise<User> => {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    const userProfile: UserProfile = {
          uid: user.uid,
          email: user.email || '',
          displayName: displayName || email.split('@')[0],
          credits: 12, // 12L starting credits (~2 min free trial)
          tier: 'micro',
          createdAt: new Date(),
    };

    await setDoc(doc(db, 'users', user.uid), userProfile);

    return user;
};

export const signIn = async (email: string, password: string): Promise<User> => {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential.user;
};

export const logOut = async (): Promise<void> => {
    await signOut(auth);
};

export const getUserProfile = async (uid: string): Promise<UserProfile | null> => {
    const docSnap = await getDoc(doc(db, 'users', uid));
    return docSnap.exists() ? (docSnap.data() as UserProfile) : null;
};

export const updateUserCredits = async (uid: string, creditsToAdd: number): Promise<void> => {
    const userRef = doc(db, 'users', uid);
    await updateDoc(userRef, {
        credits: increment(creditsToAdd),
        lastUpdated: new Date(),
    });
};
